module.exports = __webpack_public_path__ + "static/img/pic9.92b906eb.png";